<div class="consent-lock">
  <div class="consent-lock__header text-center my-2">
    <div class="consent-lock__title-row mb-1">
      <h2 mat-dialog-title class="consent-lock__title m-0">
        {{ 'app.consentLock.title' | translate }}
      </h2>
      <div class="consent-lock__toolbar d-flex align-items-center gap-2">
        <av-language-dropdown />
        <av-theme-toggle />
      </div>
    </div>
    <p class="m-0">{{ 'app.consentLock.body' | translate }}</p>
  </div>

  <div class="consent-lock__section text-center mb-3">
    <h3 class="consent-lock__section-title mb-1">
      {{ 'app.consentLock.permissionsTitle' | translate }}
    </h3>
    <p class="consent-lock__section-subtitle m-0">
      {{ 'app.consentLock.permissionsSubtitle' | translate }}
    </p>
  </div>

  <mat-dialog-content class="consent-lock__content">
    @if (loadFailed()) {
      <div class="consent-lock__state d-flex flex-column align-items-center text-center gap-3">
        <mat-icon>error</mat-icon>
        <p class="mb-0">{{ 'shared.api.errors.default' | translate }}</p>
        <button mat-stroked-button class="px-4 rounded-full" (click)="onRetryLoad()">
          <mat-icon>refresh</mat-icon>
          {{ 'app.catalog.errors.retry' | translate }}
        </button>
      </div>
    } @else {
      <div class="consent-lock__permissions">
        <av-rail [active]="listWait.visible()" />

        <div class="consent-lock__grid">
          @for (row of permissionRows(); track row.id) {
            <div class="consent-lock__permission d-flex align-items-center gap-2">
              <mat-icon class="consent-lock__permission-icon">lock</mat-icon>
              <span class="consent-lock__permission-name flex-fill text-start">{{ row.name }}</span>
              <mat-icon
                class="consent-lock__permission-hint"
                [matTooltip]="row.tooltip"
                matTooltipPosition="above"
                >info</mat-icon
              >
            </div>
          }
        </div>
      </div>
    }

    @if (errorMessage(); as message) {
      <div class="consent-lock__alert d-flex align-items-start gap-2" role="alert">
        <mat-icon>error</mat-icon>
        <span class="small">{{ message }}</span>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions
    class="consent-lock__actions d-flex justify-content-between align-items-center gap-3"
  >
    <button mat-stroked-button class="px-4 rounded-full" [disabled]="busy()" (click)="onSignOut()">
      <mat-icon>logout</mat-icon>
      {{ 'app.consentLock.signOut' | translate }}
    </button>

    @if (canManageSubscription()) {
      <a class="consent-lock__subscription ms-auto" [routerLink]="subscriptionPath">
        {{ 'app.consentLock.manageSubscription' | translate }}
      </a>
    }

    <button
      mat-flat-button
      color="primary"
      class="px-4 rounded-full"
      [avPending]="grantWait.visible()"
      [disabled]="busy()"
      (click)="onGrantConsent()"
    >
      @if (grantWait.visible()) {
        <av-spin size="sm" class="d-inline-block me-2" />
      }
      {{ (redirecting() ? 'app.consentLock.redirecting' : 'app.consentLock.grant') | translate }}
    </button>
  </mat-dialog-actions>
</div>
